/**
 * BLOCK: contact Section
 */
registerBlockType( 'tornado/contact-section', {
    title: 'قسم تواصل معنا',
    description: __('', 'tornado'),
    icon:'editor-insertmore',
    category:'tornado',
    keywords: [ 'contact', 'tornado', 'home'],
    supports: {
        align: ['full','wide']
    },
    attributes : {},

    //==== Edit Mode ====//
    edit: props => {
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        // Rendering in PHP
        return (
            <Panel>
                <PanelBody>
                    <ServerSideRender block="tornado/contact-section" />
                </PanelBody>
            </Panel>
        )
    },
    save() { // Rendering in PHP
        return null;
    },
});